import axios from 'axios';
import {
    generateAnalyticRequestPayload,
    handleGeneratedAnalyticInRegistration
} from '@/playerVue3/services/analytic-service'
export function saveForm(data) {
    return axios.post('/campaign/save/form', data, {
        withCredentials: true,
    });
}

export function getTemplateFormHTML(skeletonHTML) {
    try {
        const params = {
            file: skeletonHTML,
        };
        return axios.post('/campaign/video/get/template/form/html', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    } catch (ex) {
        console.log(ex);
    }
}

export function prepareDataAndSave(store, fields, formDataSerialize) {
    const formatValueObject = [];
    Object.keys(formDataSerialize).forEach((key) => {
        const extractedId = formDataSerialize[key]['name'].split('_')[2];
        const countFields = formDataSerialize.reduce((total,x) => (x['name']==formDataSerialize[key]['name'] ? total+1 : total), 0)
        if (extractedId) {
            if (countFields > 1) {
                if (formatValueObject[formDataSerialize[key]['name']] === undefined) {
                    formatValueObject[formDataSerialize[key]['name']] = [];
                    fields[formDataSerialize[key]['name']] = [];
                }
                formatValueObject[formDataSerialize[key]['name']].push(formDataSerialize[key]['value']);
                fields[formDataSerialize[key]['name']].push(formDataSerialize[key]['value']);
            } else {
                formatValueObject[formDataSerialize[key]['name']] = formDataSerialize[key]['value'];
                fields[formDataSerialize[key]['name']] = formDataSerialize[key]['value'];
            }
        }
    });
    store.setQuestionsAnswered(formatValueObject);

    fields['isDebug'] = store.getIsDebug;
    return saveForm(fields).then(r => {
        return r;
    });
}

export async function handleELearningRegistrationSubmit(playerStore, fields, formDataSerialize) {
    const formFields = { ...fields }
    formFields.analyticData = await generateAnalyticRequestPayload(playerStore)

    const { data: result } = await prepareDataAndSave(playerStore, formFields, formDataSerialize);

    handleGeneratedAnalyticInRegistration(playerStore, formFields.analyticData, result.analyticId)

    if (result.currentTime) {
        playerStore.getPlayer.seek(result.currentTime);
    }
}

export function replaceDataVariableInForm(store, hotspot, content) {
    let itemHTML = content.contentHtml;
    const path = store.getPathLocalOrServer;
    const varRegExp = new RegExp(/%%(.*?)%%/g);
    const variables = itemHTML.match(varRegExp);
    variables.forEach( (variable) => {
        const varRegExp2 = new RegExp(/%%(.*?)%%/g);
        const variableName = variable.match(varRegExp2)[0].replace(/%/g, '');
        if (variableName !== 'animation') {
            const variableValue = store.getDataVariableByVariableName(variableName);
            if (variableValue.length > 0) {
                const foundImage = variableValue[0].fieldExcel.description.search(content.variableName);
                if (foundImage > -1 && variableValue[0].path != null) {
                    itemHTML = itemHTML.replace(variable, path + 'images_variables/' + variableValue[0].path);
                } else if (foundImage > -1 && variableValue[0].path === null) {
                    itemHTML = itemHTML.replace(variable, path + 'images_variables/hotspot-image-referente.jpg');
                } else {
                    itemHTML = itemHTML.replace(variable, variableValue[0].description);
                }
            } else if (content.url !== null && content.url !== '' && content.url !== undefined) {
                itemHTML = itemHTML.replace(variable, path + 'images_variables/' + content.url);
            } else {
                itemHTML = itemHTML.replace(variable, '');
            }
        } else {
            if (hotspot && hotspot.hotspotAnimationIn !== '') {
                itemHTML = itemHTML.replace(variable, hotspot.hotspotAnimationIn);
            } else {
                itemHTML = itemHTML.replace(variable, '');
            }
        }
    });

    return itemHTML;
}
